import api from "./api";

const permissionRequestApi = {
    createRequest: (data) => {
        return api.post('/admin/permission-requests', data);
    },
    getPagedRequests: (pageNumber, pageSize, status) => {
        let url = `/admin/permission-requests/paged?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if (status !== null && status !== undefined) {
            url += `&status=${status}`;
        }
        return api.get(url);
    },
    approveRequest: (id) => {
        const url = `/admin/permission-requests/${id}/approve`;
        return api.post(url);
    },
    rejectRequest: (id) => {
        const url = `/admin/permission-requests/${id}/reject`;
        return api.post(url);
    },
    getUserPendingRequests: (userId) => {
        const url = `/admin/permission-requests/user/${userId}/pending`;
        return api.get(url);
    },
    getUserRequestsByStatus: (userId, status) => {
        const url = `/admin/permission-requests/user/${userId}/status/${status}`;
        return api.get(url);
    },
    getUserRequestHistory: (userId) => {
        const url = `/admin/permission-requests/user/${userId}/history`;
        return api.get(url);
    },
    resolveBulk: (data) => {
        const url = `/admin/permission-requests/resolve-bulk`;
        return api.post(url, data);
    }
};

export default permissionRequestApi;
